import { render, staticRenderFns } from "./confirmDeletionChildModal.vue?vue&type=template&id=1c0a995a&"
import script from "./confirmDeletionChildModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionChildModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports